var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("presentation",function(){return [_c('p',[_vm._v(_vm._s(_vm.chunks[_vm.position]))])]},{"chunk":_vm.chunks[_vm.position]}),(_vm.position < _vm.chunks.length)?_c('Wait',{key:_vm.position,attrs:{"time":_vm.interval},on:{"done":_vm.nextChunk}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }